import React, {Component, Fragment} from 'react';
import {LanguageSelect} from "./LanguageSelect";
import {NoInfo} from "./structure/NoInfo";
import {CopyToClipboard} from "react-copy-to-clipboard";
import '../resources/stylesheets/genericUrls.css';


class GenericUrls extends Component {

  constructor(props) {
    super(props);

    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.copyLink = this.copyLink.bind(this);

    this.state = {
      copied: {},
      urlLang: "es"
    }
  }

  handleLanguageChange(e) {
    this.setState({urlLang: e.value, copied: {}});
  }


  copyLink(itemId){
    let linkCopied = {};
    linkCopied[itemId] = true;
    let obj = {copied: linkCopied};
    this.setState(obj);
  }

  generateUrl(mainLink, currentHash, affWebsite){
    let affWeb = "&utm_medium=afiliados&utm_campaign=Afiliados&utm_source=" + affWebsite.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0];
    return mainLink + "?aff=" + currentHash + affWeb;
  }


  render(){

    const { genericUrls, languages, currentHash, affWebsite} = this.props;
    const { urlLang, copied } = this.state;
    const urlHTML = [];

    if(genericUrls && genericUrls.length > 0){
      genericUrls.forEach(gu => {

        const langLinks = JSON.parse(gu.itemLinkedUrl);
        const text = this.generateUrl(langLinks[urlLang], currentHash, affWebsite);
        const btnClass = copied[gu.affiliateItemId] ? "btn-success" : "btn-primary";
        const btnText = copied[gu.affiliateItemId] ? " Copied" : " Copy Link";

        urlHTML.push(
          <li key={gu.itemLinkedUrl} className="genericUrlLi">
          <span className="genericUrlSpan">
            <samp>{text}</samp>
          </span>
            <CopyToClipboard text={text} onCopy={() => this.copyLink(gu.affiliateItemId)}>
              <button className={`btn ${btnClass}`}>
                <span className="glyphicon glyphicon-copy copyIcon"></span>{btnText}
              </button>
            </CopyToClipboard>
          </li>
        )
      });
    }

    return (
      urlHTML.length > 0 ?
      <div className="genericUrlContainer">
        <LanguageSelect languages={languages} handleLanguageChange={(e) => this.handleLanguageChange(e)} />
        <ul>{urlHTML}</ul>
      </div>
      :
      <Fragment>
        <NoInfo displayMsg="There are no generic URLs available at this time"/>
      </Fragment>
    )
  };

}

export default GenericUrls;
